import { capfirst } from 'journalize';
import { LENGTH_OF_CHECK_INTERVAL } from './constants';

const PARTY_SORT_ORDER = [
  'democrat',
  'republican',
  'libertarian',
  'independent',
  'write-in',
];

export const presidentCandidateColors = [
  {
    name: 'Bernie Sanders',
    color: '#1755c5',
    id: 'e8f0e1e0-ce06-4824-a556-37f75a7b5173',
  },
  {
    name: 'Amy Klobuchar',
    color: '#5acc7d',
    id: 'd97c403a-bd59-4f6e-94d6-8afe7b735f78',
  },
  {
    name: 'Joseph R. Biden',
    color: '#fcbec3',
    id: 'ea10604d-e47a-468e-b7b7-3e9b43fb015b',
  },
  {
    name: 'Pete Buttigieg',
    color: '#ffc200',
    id: 'd47b167e-eec5-44b7-b24f-354da354c165',
  },
  {
    name: 'Elizabeth Warren',
    color: '#91dfe5',
    id: 'edb93d1d-cbb8-48e8-8adf-a73a09c901e4',
  },
  {
    name: 'Michael R. Bloomberg',
    color: '#FF822D',
    id: '4892e451-3cf8-4c77-b910-f9e1794ef186',
  },
  {
    name: 'Michael Bennet',
    color: '#888888',
    id: '88d47a81-5cd7-498e-a211-c12c19f029f8',
  },
  {
    name: 'Cory Booker',
    color: '#888888',
    id: 'b1eee99a-56c1-448c-be5d-c88c1428a450',
  },
  {
    name: 'Julián Castro',
    color: '#888888',
    id: '332829d6-735c-4552-8c94-ed4cc94c6310',
  },
  {
    name: 'Roque "Rocky" De La Fuente',
    color: '#888888',
    id: '40ac6c36-839e-4a2d-a2fa-0f597f86de42',
  },
  {
    name: 'John K. Delaney',
    color: '#888888',
    id: 'aad5e2b1-426f-4be3-96cc-6e589607981d',
  },
  {
    name: 'Tulsi Gabbard',
    color: '#888888',
    id: 'a44186a5-1d0c-4851-b760-eff93978e6e8',
  },
  {
    name: 'Deval Patrick',
    color: '#888888',
    id: 'ae9859d9-4514-42d6-b6e1-30979ea2b4f1',
  },
  {
    name: 'Tom Steyer',
    color: '#888888',
    id: '686aad9e-0d0f-41b7-9a14-e9c6eb5a5583',
  },
  {
    name: 'Robby Wells',
    color: '#888888',
    id: '645793e1-394a-4778-a6d9-26a83c3f17ba',
  },
  {
    name: 'Marianne Williamson',
    color: '#888888',
    id: '04ed822a-fffd-4d41-9cb6-876143ceb4c2',
  },
  {
    name: 'Andrew Yang',
    color: '#888888',
    id: '408cf41b-6450-47a2-905a-4cde7e577226',
  },
];

export const senateCandidateColors = [
  {
    name: 'Chris Bell',
    color: '#91dfe5',
    id: '50de2927-a6e0-4008-b0cc-d1187aa139b2',
  },
  {
    name: 'Michael Cooper',
    color: '#888888',
    id: '170eb94b-714b-4514-a850-2b52606ee7b2',
  },
  {
    name: 'Amanda K. Edwards',
    color: '#ffc200',
    id: '775fcfa6-4eee-483e-ac7d-eafb2979d4cc',
  },
  {
    name: 'Jack Daniel Foster Jr.',
    color: '#888888',
    id: 'fbf493e5-f979-4beb-bff6-8abdfa032246',
  },
  {
    name: 'Annie "Mamá" Garcia',
    color: '#FF822D',
    id: '2e61ecb0-2bd7-4d67-a94d-65e1bdba13d0',
  },
  {
    name: 'Victor Hugo Harris',
    color: '#888888',
    id: 'f928f369-4338-465e-9ef4-ed79bfe2e0b1',
  },
  {
    name: 'Mary "MJ" Hegar',
    color: '#1755c5',
    id: '5eef65f9-b464-44c2-a269-2b9f265b4837',
  },
  {
    name: 'Sema Hernandez',
    color: '#182b4b',
    id: '85ba7cdc-80d6-4ee8-a23d-238d0d9e3f06',
  },
  {
    name: 'D. R. Hunter',
    color: '#888888',
    id: '13b29be8-d8c7-43bc-b5ae-289e1aadd142',
  },
  {
    name: 'Adrian Ocegueda',
    color: '#888888',
    id: '7f9a6f05-fa6b-4447-8d43-2d03ed9e6261',
  },
  {
    name: 'Cristina Tzintzún Ramirez',
    color: '#fcbec3',
    id: '01b59a67-89a5-4fe3-947e-52dba799e240',
  },
  {
    name: 'Royce West',
    color: '#5acc7d',
    id: '3894feeb-6314-454b-a1b3-b7b7e3a8991c',
  },
];




const TT_directory_slugs = [{'office': 'Texas House', 'directory-slug': 'tx-house'},  {'office': 'Texas Senate', 'directory-slug': 'tx-senate'}, {'office': 'U.S. House', 'directory-slug': 'us-house'}, {'office': 'State Board of Education', 'directory-slug': 'sboe'}];

export function get_directory_slug(office) {
  return TT_directory_slugs.filter(slug => slug.office == office)
}

export function sort_candidates_by_party(candidates) {
  return candidates.sort(
    (a, b) =>
      PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
  );
}

export function countdown(minutes) {
  var seconds = 60;

  var now = new Date().getTime();
  // target timestamp; we will compute the remaining time
  // relative to this date.
  var target = new Date(now + LENGTH_OF_CHECK_INTERVAL);
  // update frequency; note, this is flexible, and when the tab is
  // inactive, there are no guarantees that the countdown will update
  // at this frequency.
  var update = 500;

  var int = setInterval(function () {
    var countdown_div = document.querySelectorAll('.countdown');
    // current timestamp
    var now = new Date();
    // remaining time, in seconds
    var remaining = (target - now) / 1000;
    
    // if done, alert
    if (remaining < 1 && remaining > 0 ) {
      Array.prototype.forEach.call(countdown_div, function(el) {
        el.innerHTML = "Updating"
      });
      return;
  
    }

    if (remaining < 0) {
      clearInterval(int);
      return;
    }
    
    // format
    var minutes = ~~(remaining / 60);
    var seconds = ~~(remaining % 60);
  
    
    // display
    Array.prototype.forEach.call(countdown_div, function(el) {

      el.innerHTML = "Update in <span class='counter'>" + 
      format(minutes) + ":" + format(seconds) + "</span>"
    })
  }, update);
}

function format(num) {
  return num < 10 ? "0" + num : num;
}


//   function tick() {
//     var counter = document.querySelectorAll('.counter');
//     var countdown_div = document.querySelectorAll('.countdown');
//     var current_minutes = minutes - 1;

//     seconds--;

//     Array.prototype.forEach.call(countdown_div, function(el) {
//       el.innerHTML = "Update in <span class='counter'>" + 
//         current_minutes.toString() +
//         ':' +
//         (seconds < 10 ? '0' : '') +
//         String(seconds) + "</span>"
//     });

//     if (seconds > 0) {
//       setTimeout(tick, 1000);
//     } else {
//       if (minutes > 1) {
//         countdown(minutes - 1);
//       }
//       if (minutes == 1 && seconds == 0) {
//         Array.prototype.forEach.call(countdown_div, function(el) {
//       el.innerHTML = "Updating"
//     });
//       }
//     }
//   }
//   tick();
// }

export function determineDistrictTitle(contest) {
  return `${contest.office} ${
    contest.office === 'President' || contest.division_type === 'class' ? '' : (contest.division_type === 'place' && contest.office_division === 1) ? 'Chief Justice' : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

export function determineContestTitle(contest) {
  if (contest.division_type === 'statewide' || contest.division_type === 'seat')
    return '';

  return determineDistrictTitle(contest);
}

export function determineContestTitleYourRaces(contest) {
  return determineDistrictTitle(contest);
}
